import { Field, inputCls } from "./Field";

const methods = [
  { k: "email", l: "Email" },
  { k: "phone", l: "Phone call" },
  { k: "text", l: "Text message" },
];

export const StepContact = ({ f, set, errors }) => (
  <div className="space-y-6">
    <Field label="Full name" error={errors.name}>
      <input data-testid="name-input" className={inputCls} value={f.name} onChange={(e) => set("name", e.target.value)} placeholder="Your name" autoComplete="name" />
    </Field>
    <div className="grid gap-6 sm:grid-cols-2">
      <Field label="Email" error={errors.email}>
        <input data-testid="email-input" type="email" className={inputCls} value={f.email} onChange={(e) => set("email", e.target.value)} placeholder="you@example.com" autoComplete="email" />
      </Field>
      <Field label="Phone" error={errors.phone}>
        <input data-testid="phone-input" type="tel" className={inputCls} value={f.phone} onChange={(e) => set("phone", e.target.value)} placeholder="07…" autoComplete="tel" />
      </Field>
    </div>
    <div>
      <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">Preferred contact</span>
      <div className="mt-2 grid grid-cols-3 gap-2">
        {methods.map((m) => (
          <button
            key={m.k}
            type="button"
            data-testid={`contact-${m.k}-option`}
            onClick={() => set("preferred_contact", m.k)}
            className={`border px-3 py-3 text-sm font-medium transition-[border-color,background-color] duration-300 ${
              f.preferred_contact === m.k ? "border-ember bg-ember/10 text-bone" : "border-white/10 text-slate-300 hover:border-white/30"
            }`}
          >
            {m.l}
          </button>
        ))}
      </div>
    </div>
  </div>
);
